export default __webpack_public_path__ + "static/media/graph-dark.50fff0ae.svg";